import { CardContent } from "@volca/ui/components/ui/card";
import { PageMainCard } from "@volca/ui/components/ui/page-components";
import { PackChatPanel } from "@/payroll/pack-chat/pack-chat-panel";
import { PayBreakdownPaneShell } from "./pay-breakdown-pane-shell";

interface PayBreakdownPackChatTabProps {
  businessId: string | null;
  periodStart: string | undefined;
  /** The run whose workbook this page is showing. */
  runId: string | null;
  isLocked?: boolean;
}

// Questions technicians raised about their packs, as its own tab.
//
export const PayBreakdownPackChatTab = ({
  businessId,
  periodStart,
  runId,
  isLocked,
}: PayBreakdownPackChatTabProps) => (
  <PayBreakdownPaneShell fillHeight>
    <PageMainCard className="min-w-0">
      {/* No padding at all: every pane scrolls to the card's own edges and carries
          its inset inside its scrolled content. Padding out here left content
          vanishing into a blank band and pushed each scrollbar 20px in from the
          frame — the scroll read as broken rather than as scrolled. */}
      <CardContent className="min-h-0 flex-1 overflow-y-auto p-0">
        {/* Columns: technicians, their questions, the conversation, the pack. */}
        <PackChatPanel
          businessId={businessId}
          periodStart={periodStart}
          runId={runId}
          isLocked={isLocked}
        />
      </CardContent>
    </PageMainCard>
  </PayBreakdownPaneShell>
);
